import AxiosBase from "@/assets/js/axios-base";
import Axios from "@/assets/js/axios";

let axiosBase = new AxiosBase();
let $axios = Axios.http;
let $download = Axios.download;

const state = {
  baseDistanceList: []
};

const getters = {};

const actions = {
  async fetchAllBaseDistance({ commit, state }, getParams) {
    let pageCount = getParams.pageCount;
    return $axios
      .get(axiosBase.getUrls().getAllBaseDistanceList, {
        params: getParams
      })
      .then(value => {
        if (pageCount === 0) {
          commit("clearAllBaseDistanceData");
        }
        commit("appendAllBaseDistanceData", value.data.data);
      });
  },
  async fetchBaseDistance({ commit, state }, id) {
    return await $axios.get(axiosBase.getUrls().getAllBaseDistance + id).then(value => {
      return value.data.data;
    });
  },
  // 実績出力
  async export({ commit, state }, getParams) {
    return $download.get(axiosBase.getUrls().getBaseDistanceExport, {
      params: getParams
    });
  }
};

const mutations = {
  clearAllBaseDistanceData(state) {
    state.baseDistanceList = [];
  },
  appendAllBaseDistanceData(state, data) {
    if (data != null) {
      state.baseDistanceList = state.baseDistanceList.concat(data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
